<button
  mat-icon-button
  type="button"
  aria-label="Contact support"
  matTooltip="Contact support"
  (click)="openSupportDialog()"
>
  <mat-icon [svgIcon]="'heroicons_outline:question-mark-circle'"></mat-icon>
</button>
